import React, { useEffect, useState } from "react";
import { useAuth } from "component/UseAuth";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import Datatables from "component/hrd/absensi/Datatables";
import UploadAbsensi from "component/hrd/absensi/UploadAbsensi";

function Absensi() {
  const { user } = useAuth();
  const [activeContent, setActiveContent] = useState("data");
  const [absensi, setAbsensi] = useState([]);

  const fetchAbsensi = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/show-absensi`,
        {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      if (!response.ok) throw new Error("Gagal mengambil data employee");

      const data = await response.json();
      setAbsensi(data.data);
    } catch (error) {
      console.error("Error fetching employee:", error);
    }
  };

  useEffect(() => {
      document.title = "Green Hill Kemuning | Employee";
      window.scrollTo(0, 0);
  }, []);


  const handleUploadAbsensi = () => {
    setActiveContent("upload");
  }

  const handleBack = () => {
    setActiveContent("data");
  };
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">

                          {activeContent === "data" && (
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">Absensi Management</h5>
                              <i className="bx bxs-plus-square" 
                                style={{ color: "blue", fontSize: 50, cursor: "pointer" }} 
                                onClick={handleUploadAbsensi}>
                              </i>
                            </div>
                            <Datatables data={absensi} onFetchAbsensi={fetchAbsensi}/>
                          </div>
                          )}

                          {activeContent === "upload" && (
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">Upload Absensi</h5>
                            </div>
                            <UploadAbsensi
                              user={user}
                              onBack={handleBack}
                            />
                          </div>
                          )}

                        </div>  
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>

    </div>
  );
}

export default Absensi;
